import React from 'react';

import './LoaderSpinner.scss';

const LoaderSpinner: React.FunctionComponent<{ className?: string }> = ({
  className,
}) => <div className={`loader-spinner ${className || ''}`}></div>;

export default LoaderSpinner;
